import { MapsAPILoader } from '@agm/core';
import { Component, ElementRef, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { CustomLabel, LatLong, WayPoint } from 'src/app/Model/Shipping/way-point';
import { getWindow } from 'ssr-window';

@Component({
  selector: 'app-new-order-map-dialog',
  templateUrl: './new-order-map-dialog.component.html',
  styleUrls: ['./new-order-map-dialog.component.css']
})
export class NewOrderMapDialogComponent {

  private isDragging: boolean = false;
  private dragStartX: number;
  private dragStartY: number;
  private dialogStartX: number;
  private dialogStartY: number;

  storeLatitude: number;
  storeLongitude: number;
  waypoints: WayPoint[] = [];
  customLabel: CustomLabel[] = [];

  origin: LatLong = new LatLong();
  destination: LatLong = new LatLong();

  lastLati: number;
  lastLongi: number;
  fromAddress: string;
  isShowMap: boolean = false;
  message: string;
  distance: string;
  price: string;
  toAddress: string;
  latitude: string;
  longitude: string;

  public renderOptions = {
    suppressMarkers: true,
  };

  markerOptions = {
    destination: { label: { color: 'white', text: 'PL' }, infoWindow: '' },
    origin: {
      visible: true, infoWindow: ''
    }
  };

  constructor(
    private dialogRef: MatDialogRef<NewOrderMapDialogComponent>,
    private mapsAPILoader: MapsAPILoader,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private elementRef: ElementRef
  ) {
    dialogRef.disableClose = true;

  }

  ngOnInit() {
    console.log(this.data);
    this.message = this.data.message;
    const parts = this.message.split("===");
    console.log(parts);
    parts.forEach(part => {
      if (part.startsWith("Distance:")) {
        this.distance = part.replace("Distance:", "").trim();
      } else if (part.startsWith("Price:")) {
        this.price = part.replace("Price:", "").trim();
      } else if (part.startsWith("FromAddress:")) {
        this.fromAddress = part.replace("FromAddress:", "").trim();
      } else if (part.startsWith("ToAddress:")) {
        this.toAddress = part.replace("ToAddress:", "").trim();
      } else if (part.startsWith("Latitude:")) {
        this.latitude = part.replace("Latitude:", "").trim();
        this.lastLati = Number(this.latitude);
      } else if (part.startsWith("Longitude:")) {
        this.longitude = part.replace("Longitude:", "").trim();
        this.lastLongi = Number(this.longitude);
      }
    });

    this.getGoogleMap();
  }

  onMouseDown(event: MouseEvent) {
    this.isDragging = true;
    this.dragStartX = event.clientX;
    this.dragStartY = event.clientY;
    
    const dialogElement = this.elementRef.nativeElement.querySelector('.mainDiv');
    const rect = dialogElement.getBoundingClientRect();
    this.dialogStartX = rect.left;
    this.dialogStartY = rect.top;

    document.addEventListener('mousemove', this.onMouseMove.bind(this));
    document.addEventListener('mouseup', this.onMouseUp.bind(this));
  }

  onMouseMove(event: MouseEvent) {
    if (!this.isDragging) return;

    const dx = event.clientX - this.dragStartX;
    const dy = event.clientY - this.dragStartY;

    const dialogElement = this.elementRef.nativeElement.querySelector('.mainDiv');
    dialogElement.style.left = `${this.dialogStartX + dx}px`;
    dialogElement.style.top = `${this.dialogStartY + dy}px`;
  }

  onMouseUp() {
    this.isDragging = false;
    document.removeEventListener('mousemove', this.onMouseMove.bind(this));
    document.removeEventListener('mouseup', this.onMouseUp.bind(this));
  }

  hide() {
    this.dialogRef.close()
  }

  //Google map
  getGoogleMap() {
    this.mapsAPILoader.load().then(() => {
      this.setCurrentLocation();
    });
  }

  private setCurrentLocation() {
    if ('geolocation' in navigator) {
      navigator.geolocation.getCurrentPosition((position) => {
        this.storeLatitude = position.coords.latitude;
        this.storeLongitude = position.coords.longitude;

        this.drawMapData();
      });
    }
  }

  drawMapData() {
    this.waypoints = [];
    this.customLabel = [];

    this.origin.lat = this.storeLatitude;
    this.origin.lng = this.storeLongitude;

    this.destination.lat = this.lastLati;
    this.destination.lng = this.lastLongi;

    let url = "";
    if (this.getOS() == "Android")
      url = 'geo:' + this.destination.lat + ',' + this.destination.lng
    else
      url = 'https://www.google.com/maps/dir/' + this.origin.lat + ',' + this.origin.lng + '/' + this.destination.lat + ',' + this.destination.lng;
    this.markerOptions.destination.infoWindow = this.fromAddress + "<br><a href=" + url + " target='_blank'>View on google maps</a>"

    let index: number;

    this.isShowMap = true;
  }

  getOS() {
    var uA = getWindow().navigator.userAgent || getWindow().navigator.vendor;
    if (
      /iPad|iPhone|iPod/.test(uA) ||
      (uA.includes('Mac') && 'ontouchend' in document)
    )
      return 'iOS';
    var i,
      os = ['Windows', 'Android', 'Unix', 'Mac', 'Linux', 'BlackBerry'];
    for (i = 0; i < os.length; i++)
      if (new RegExp(os[i], 'i').test(uA)) return os[i];
  }

}
